//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'
import { Language } from '@constants'

const FIND_ARTICLES = gql`
  query ($where: ArticleSearchWhereInput) {
    searchArticles(where: $where) {
      id
      externalId
      date
      title
      slug
      contentType {
        id
        name
        contentTypeGroup {
          id
          name
        }
      }
    }
  }
`

export default {
  name: 'GlobalSearch',
  data() {
    return {
      showing: false,
      searching: false,
      text: null,
      textSearched: null,
      totalFound: 0,
      articles: []
    }
  },
  computed: {
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    languageId() {
      return this.language === 'en' ? Language.ENGLISH : Language.DUTCH
    }
  },
  watch: {
    articles(value) {
      this.showing = value.length > 0
    }
  },
  beforeDestroy() {
    this.$nuxt.$off('search-results-found')
  },
  mounted() {
    this.$nuxt.$on('search-results-found', (val) => {
      this.totalFound = val
    })
  },
  methods: {
    async findArticles() {
      this.searching = true

      try {
        const { data } = await this.$apollo.query({
          query: FIND_ARTICLES,
          variables: {
            where: {
              text: this.text,
              languageId: this.languageId,
              queryBy: ['TITLE', 'FULL_TEXT', 'COMPANY'],
              useTypesense: false,
              sortBy: 'date:desc',
              articleId: null,
              direction: 'BACKWARD',
              startAt: this.$dayjs().subtract(1, 'year'),
              endAt: this.$dayjs().endOf('day')
            },
            fetchPolicy: 'network-only'
          }
        })

        this.textSearched = this.text
        this.articles = data.searchArticles
        this.showing = true
      } catch (error) {
        this.handleError(error)
      } finally {
        this.searching = false
      }
    },
    onSearchInput() {
      this.textSearched = ''
      this.articles = []
      clearTimeout(this.debounce)

      this.debounce = setTimeout(() => {
        if (this.text == null || this.text?.trim() === '') {
          this.showing = false
        } else {
          this.findArticles()
        }
      }, 300)
    },
    onSearchIconClick() {
      if (this.text?.trim().length > 0) {
        this.onSearchEnter()
      } else {
        this.$router.push({ path: '/search' })
      }
    },
    onSearchFocus() {
      this.$nuxt.$emit('searching', true)

      if (this.text) {
        this.showing = true
      }
    },
    onSearchEnter() {
      const filters = JSON.parse(JSON.stringify(this.defaultFilters))
      if (this.text) {
        filters.text = this.text
      }

      if (this.$route.name !== 'search') {
        this.$router.push({
          path: '/search',
          query: { f: encodeURIComponent(window.btoa(JSON.stringify(filters))) }
        })
      }

      this.$nuxt.$emit('search-changed-globally', filters.text)
      this.clear()
    },
    onArticleSelect() {
      this.clear()
    },
    onClickOutside() {
      // add delay to determine if click was on search result or outside
      setTimeout(() => {
        this.showing = false
        this.$nuxt.$emit('searching', false)

        if (document.activeElement instanceof HTMLElement) document.activeElement.blur()
      }, 200)
    },
    clear() {
      this.showing = false
      this.text = null
      this.$nuxt.$emit('searching', false)

      // add delay so when transitioning out the search box does not weirdly change size
      setTimeout(() => {
        this.articles = []
        this.textSearched = null
      }, 500)
    }
  }
}
